export default "__VITE_ASSET__C4Yo4dU5__"